import React, { useState } from 'react'
import { IconButton, Snackbar, Tooltip } from '@mui/material'
import ContentCopyIcon from '@mui/icons-material/ContentCopyOutlined'
import { useTranslation } from 'react-i18next'

import { CopyEntityDialog, CopyLevel } from './CopyEntityDialog'

type Props = {
  level: CopyLevel
  sourceId: string
  currentPoiId?: string
  currentSectionId?: string
  currentNuggetId?: string
  onCopied?: () => void
  iconSx?: object
}

/** Unified copy widget: an icon button that opens the cascading target picker. */
export const CopyEntityButton: React.FC<Props> = ({ iconSx, ...dialogProps }) => {
  const { t } = useTranslation()
  const [open, setOpen] = useState(false)
  const [snackbar, setSnackbar] = useState(false)

  const label = dialogProps.level === 'poi' ? t('common.duplicate') : t('common.copy')

  return (
    <>
      <Tooltip title={label}>
        <IconButton
          size="small"
          onClick={(e) => { e.stopPropagation(); e.preventDefault(); setOpen(true) }}
          sx={{ p: 1, minWidth: 0, color: '#666', ...iconSx }}
        >
          <ContentCopyIcon fontSize="small" sx={{ fontSize: 16 }} />
        </IconButton>
      </Tooltip>

      <CopyEntityDialog
        {...dialogProps}
        open={open}
        onClose={() => setOpen(false)}
        onCopied={() => { setSnackbar(true); dialogProps.onCopied?.() }}
      />

      <Snackbar
        open={snackbar}
        autoHideDuration={3000}
        onClose={() => setSnackbar(false)}
        message={t('edit.copy.copied')}
      />
    </>
  )
}
